async function vpdcUpdateGoalBanner() {
  try {
    const res = await fetch('/cart.js');
    if (!res.ok) return;
    const cart = await res.json();

    const goalCents = 5900;
    const total = cart.items_subtotal_price || 0;

    const remainingCents = Math.max(goalCents - total, 0);
    const remainingEuro = (remainingCents / 100).toFixed(2).replace('.', ',');
    const progress = Math.min(100, Math.round((Math.min(total, goalCents) * 100) / goalCents));

    document.querySelectorAll('.vpdc-goal-banner').forEach(banner => {
      const textEl = banner.querySelector('[data-vpdc-text]');
      const barEl  = banner.querySelector('[data-vpdc-bar]');

      if (textEl) {
        if (remainingCents > 0) {
          textEl.innerHTML =
            `Ti mancano <strong>${remainingEuro}€</strong> ` +
            `per ricevere in regalo l’<strong>Abito Lima</strong> (valore €30,00).`;
        } else {
          textEl.innerHTML =
            `Hai sbloccato l’<strong>Abito Lima</strong> in regalo! ` +
            `Verrà aggiunto automaticamente al tuo ordine. 🙌`;
        }
      }

      if (barEl) {
        barEl.style.background = `linear-gradient(
          90deg,
          #ff7a5c 0%,
          #ff7a5c ${progress}%,
          #e8ded6 ${progress}%,
          #e8ded6 100%
        )`;
      }
    });
  } catch (e) {
    console.error('VPDC goal banner update error', e);
  }
}

// al load pagina (product / cart)
document.addEventListener('DOMContentLoaded', () => {
  vpdcUpdateGoalBanner();

  // intercetta i click sui pulsanti "add to cart" e aggiorna dopo
  document.querySelectorAll('form[action*="/cart/add"] button[type="submit"], button[name="add"]').forEach(btn => {
    btn.addEventListener('click', () => {
      // aspetta un attimo che il tema aggiorni il carrello, poi ricalcola
      setTimeout(vpdcUpdateGoalBanner, 700);
    });
  });
});
